import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicAccountUserUpdateParamsRawI,
	LWApiPublicAccountUserUpdateResultRawI,
} from '@liquidweb-dev/club-sauce/public/account/user/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { VPN_USER_LIST_QUERY_KEY } from 'modules/queries/vpn/user/useList';
import { ACCOUNT_USER_LIST_QUERY_KEY } from './useList';
import { ACCOUNT_USER_DETAILS_QUERY_KEY } from './useDetails';

const useAccountUserUpdate = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicAccountUserUpdateResultRawI,
		ApiErrorI,
		LWApiPublicAccountUserUpdateParamsRawI
	>({
		mutationFn: (params) => api.account.user.apiRaw.update(params),

		onSuccess: (data) => {
			queryClient.invalidateQueries({
				queryKey: [ACCOUNT_USER_LIST_QUERY_KEY],
			});
			queryClient.invalidateQueries({
				queryKey: [ACCOUNT_USER_DETAILS_QUERY_KEY, { username: data.username }],
			});
			queryClient.invalidateQueries({
				queryKey: [VPN_USER_LIST_QUERY_KEY],
			});
		},

		onError: snackbarError,
	});
};

export default useAccountUserUpdate;
